import React from 'react'
import { Flex } from '@chilipiper/design-system'
import { UserAvatar } from '@chilipiper/meetings-components'

interface Member {
  id: string
  name: string
}

interface Props {
  index: number
  member: Member
  size: number
}

export const GroupMember: React.FC<Props> = ({ index, member, size }) => {
  const isFirstMember = index === 0
  return (
    <Flex justifyContent='center' w={10} zIndex={10 - index} ml={isFirstMember ? 0 : -7}>
      <UserAvatar
        data-test-id={`GroupMember-avatar-${member.id}`}
        isTwoInitials
        name={member.name}
        id={member.id}
        size={size}
        borderRadius={16}
        imageStyle={{
          boxShadow: 'none',
          boxSizing: 'content-box',
          border: '2px solid #f7f9fa',
        }}
      />
    </Flex>
  )
}
